<template>
    <div class="iframe-container">
        <iframe v-if="video_url && show_video"
            frameBorder="0" 
            scrolling="no"
            allow="autoplay"
            allowfullscreen
            @load="loadVideo"
            :src="video_url">
        </iframe>
    </div>
</template>

<script>
    export default {
        name: "VideoPlayer",

        props: {
            video_id: String,
            video_src: String,
            video_type: String,
        },

        data() {
            return {
                show_video: false,
                show_loader: true
            };
        },

        computed: {
            video_url: function () {
                return this.video_src == 'YouTube' ? `https://www.youtube.com/embed/${this.video_id}?controls=1` : this.video_id
            }
        },

        mounted () {
            this.loadVideo()
        },

        methods: {
            loadVideo: function () {
                this.show_video = true
                this.show_loader = false
            }
        }
    }
</script>

<style scoped>
    .iframe-container {
        position: relative;
        width: 100%;
        padding-bottom: 56.25%; 
        height: 0;
    }
    .iframe-container iframe {
        position: absolute;
        top:0;
        left: 0;
        width: 100%;
        height: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/components/video/VideoPlayer.vue